<template>
  <main id="home">
    <hero/>
    <keyinvestment/>
    <ammolite/>
    <timeline/>
    <investment/>
    <performance/>
    <disclaimer/>
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import hero from '@/components/hero.vue';
import keyinvestment from '@/components/keyinvestment.vue';
import ammolite from '@/components/ammolite.vue';
import timeline from '@/components/timeline.vue';
import investment from '@/components/investment.vue';
import performance from '@/components/performance.vue';
import disclaimer from '@/components/disclaimer.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    hero,
    keyinvestment,
    ammolite,
    timeline,
    investment,
    performance,
    disclaimer
  },
  mounted() {
  },
};
</script>
